export var modalServiceVisibleModalsSelector = function (state) { return (state === null || state === void 0 ? void 0 : state.content) || []; };
